import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import Box from "@material-ui/core/Box"
import Img from "gatsby-image"

import img1 from "../images/logo1.png"

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}))

export default function AppNavBar() {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <AppBar position="static" style={{ background: "transparent" }}>
        <Toolbar>
          <Box mt={1} display="flex" alignItems="center" height="48px">
            <img src={img1} height="50px" style={{ marginTop: "5px" }} />
          </Box>
        </Toolbar>
      </AppBar>
    </div>
  )
}
